document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);
  if (!window.gsap || !window.ScrollTrigger) return;

  document.querySelectorAll(".section").forEach(group => {
    // --- GSAP Fade Up Animation ---
    const items = group.querySelectorAll(".gsap-fadeup");
    // Check if the NodeList is not empty
    if (items.length > 0) {
      gsap.fromTo(
        items,
        { autoAlpha: 0, y: 50 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: group,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        }
      );
    }
    
    // --- GSAP Zoom In Animation ---
    const itemsImgs = group.querySelectorAll(".gsap-zoomin");
    // Check if the NodeList is not empty
    if (itemsImgs.length > 0) {
      gsap.fromTo(
        itemsImgs,
        { autoAlpha: 0, y: 0, scale: 0.9 },
        {
          autoAlpha: 1,
          scale: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: group,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        }
      );
    }
  });

  // Images parallax
  gsap.utils.toArray('.images-parallax').forEach(container => {
    const img = container.querySelector('img');

    // Read single attribute (default 20 if missing)
    const val = parseFloat(container.dataset.parallaxMove) || 20;

    // Increase the height of the img
    const extraHeight = (img.offsetHeight * (val / 100)) * 2; 
    // img.style.height = (img.offsetHeight + extraHeight) + "px";

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        scrub: true,
        pin: false,
      }
    });

    tl.fromTo(img, 
      { yPercent: -val, ease: 'none' }, 
      { yPercent: val, ease: 'none' }
    );
  });

  document.querySelectorAll('.product-details ul li').forEach(li => {
    li.textContent = li.textContent.replace(/^\s*-\s*/, '');
});


  // Run only on the custom jewelry page
  if (document.body.classList.contains('template-page-custom-jewelry')) {

    // Find the outer Shopify section wrappers for both target sections
    const inspiredWrapper = document.querySelector('.custom-jewelry-marquee')?.closest('.shopify-section');
    const marqueeWrapper = document.querySelector('.fromsaughter')?.closest('.shopify-section');

    if (inspiredWrapper && marqueeWrapper) {
      // Create the wrapper div
      const wrapper = document.createElement('div');
      wrapper.className = 'custom-jewelry-wrapper';

      // Insert the wrapper before the first section
      inspiredWrapper.parentNode.insertBefore(wrapper, inspiredWrapper);

      // Move both section wrappers into the new wrapper
      wrapper.appendChild(inspiredWrapper);
      wrapper.appendChild(marqueeWrapper);
    }
  }


    // Run only on the custom jewelry page
  if (document.body.classList.contains('template-page-collabs')) {

    // Find the outer Shopify section wrappers for both target sections
    const collabcontent = document.querySelector('.collab-hero-content')?.closest('.shopify-section.section-wrapper');
    const collabmarquee = document.querySelector('.custom-jewelry-marquee')?.closest('.shopify-section');

    if (collabcontent && collabmarquee) {
      // Create the wrapper div
      const wrapper = document.createElement('div');
      wrapper.className = 'custom-collab-wrapper';

      // Insert the wrapper before the first section
      collabcontent.parentNode.insertBefore(wrapper, collabcontent);

      // Move both section wrappers into the new wrapper
      wrapper.appendChild(collabcontent);
      wrapper.appendChild(collabmarquee);
    }
  }




});